import React from "react";
import { Link } from "../lib/LocalizedLink";
import { ArrowRight, Home } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { brand } from "../mock/content";
import { t } from "../lib/ui";
import Seo from "../seo/Seo";

export default function NotFound() {
  return (
    <div className="bg-black min-h-screen flex flex-col">
      <Seo
        title={t("nf_t")}
        description={t("nf_sd")}
        path="/404"
        noindex
        statusCode={404}
      />
      <Header />
      <main className="flex-1 flex items-center" data-testid="not-found-page">
        <div className="max-w-[1440px] w-full mx-auto px-6 lg:px-10 py-24 md:py-32">
          <span className="block font-black text-white/10 leading-none tracking-tighter text-[26vw] md:text-[16vw]" style={{ fontFamily: "Archivo" }}>404</span>
          <div className="-mt-6 md:-mt-10 max-w-2xl">
            <span className="text-white/60 text-[12px] uppercase tracking-[0.28em]" style={{ fontFamily: "Space Grotesk" }}>{t("nf_err")}</span>
            <h1 className="mt-4 text-white font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight" style={{ fontFamily: "Archivo" }}>
              {t("nf_h")}
            </h1>
            <p className="mt-5 text-white/60 text-base md:text-lg" style={{ fontFamily: "Inter" }}>
              {t("nf_p")}
            </p>
            <div className="mt-9 flex flex-wrap gap-4">
              <Link
                to="/"
                data-testid="notfound-home-btn"
                className="inline-flex items-center gap-2 px-7 py-4 text-black text-[13px] uppercase tracking-[0.14em] font-semibold transition-transform hover:scale-[1.03]"
                style={{ background: brand.yellow, fontFamily: "Space Grotesk" }}
              >
                <Home size={16} /> {t("nf_home")}
              </Link>
              <Link
                to="/prodotti"
                data-testid="notfound-products-btn"
                className="inline-flex items-center gap-2 px-7 py-4 border border-white/20 text-white text-[13px] uppercase tracking-[0.14em] font-semibold hover:border-white transition-colors"
                style={{ fontFamily: "Space Grotesk" }}
              >
                {t("nf_prod")} <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
